export { matchers } from './matchers.js';

export const nodes = [() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')];

export const server_loads = [];

export const dictionary = {
	"/(app)": [7,[2],[3]],
	"/admin": [23,[6]],
	"/auth/signin": [24],
	"/auth/signup": [25],
	"/(app)/insight": [8,[2,4],[3]],
	"/(app)/insight/stepper": [9,[2,4,5],[3]],
	"/(app)/insight/stepper/01step": [10,[2,4,5],[3]],
	"/(app)/insight/stepper/02step": [11,[2,4,5],[3]],
	"/(app)/insight/stepper/03step": [12,[2,4,5],[3]],
	"/(app)/insight/stepper/04step": [13,[2,4,5],[3]],
	"/(app)/insight/stepper/05step": [14,[2,4,5],[3]],
	"/(app)/insight/stepper/06step": [15,[2,4,5],[3]],
	"/(app)/insight/stepper/07step": [16,[2,4,5],[3]],
	"/(app)/insight/stepper/08chart": [17,[2,4,5],[3]],
	"/(app)/insight/stepper/09consult": [18,[2,4,5],[3]],
	"/(app)/insight/stepper/10complete": [19,[2,4,5],[3]],
	"/(app)/parallax2": [21,[2],[3]],
	"/(app)/parallax": [20,[2],[3]],
	"/(app)/sticky": [22,[2],[3]]
};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};